import { authServiceAxiosClient } from '@/lib';
import { withLogger } from '@/utils';

import { userProfileAPIUrls } from '../data';

type Response = {
  success: boolean;
  message: {
    [key: string]: string;
  };
};

export const saveUserProfile = withLogger(
  async (payload): Promise<Response> => {
    const url = userProfileAPIUrls.save;

    const { data } = await authServiceAxiosClient.post<Response>(url, payload);

    return data;
  },
);
